export const UNIVERSAL_CREATE_BUTTON_ID = 'universalCreate';
